import CountdownBehavior from "../behaviours/countdown-timer-behaviour";

require("../../scss/app-homepage.scss");

import BackgroundImageBehaviour from '../behaviours/background-image-behaviour';
import MobileMenuBehavior from "../behaviours/mobile-menu-behaviour";
import EqualizeBehavior from "../behaviours/equalize-behaviour";
import ShortlistCount from "../jsx/shortlist/shortlist-count";
import ShortlistButton from '../jsx/shortlist/shortlist-button';
import SearchTemplateBasic from "../jsx/search/template-basic";
import HideShowBehaviour from "../behaviours/hide-show-behaviour";
import ToggleClassBehavior from "../behaviours/toggle-class-behaviour";
import CarouselBehaviour from "../behaviours/carousel-behaviour";
import BlockEventBehaviour from "../behaviours/block-event-behaviour";
import Application from "./application";

let config = {};
config.behaviours = {
    "BackgroundImage": new BackgroundImageBehaviour(),
    "MobileMenuBehaviour": new MobileMenuBehavior(),
    "EqualizeBehaviour": new EqualizeBehavior(),
    "HideShowBehaviour": new HideShowBehaviour(),
    "ToggleClassBehaviour": new ToggleClassBehavior(),
    "CountdownBehaviour": new CountdownBehavior(),
    "CarouselBehaviour": new CarouselBehaviour(),
    "BlockEventBehaviour": new BlockEventBehaviour(),
};

config.components = {
    "shortlist-count": ShortlistCount,
    "search-form": SearchTemplateBasic,
    "shortlist-button": ShortlistButton,
}

new Application(config);